import { rolesConstants } from '../constants/index';

const accessControlsMetaData = {
    roles: {
        [rolesConstants.OIDC_ROLES.GST_ADMIN]: {
            value: rolesConstants.OIDC_ROLES.GST_ADMIN,
            active: false,
            composite_roles: ['customer_support', 'customer_viewer', 'customer_reports'],
        },
        [rolesConstants.OIDC_ROLES.GST_CUSTOMER_SUPPORT]: {
            value: rolesConstants.OIDC_ROLES.GST_CUSTOMER_SUPPORT,
            active: false,
            composite_roles: ['customer_support', 'customer_viewer'],
        },
        [rolesConstants.OIDC_ROLES.GST_FINANCE_USER]: {
            value: rolesConstants.OIDC_ROLES.GST_FINANCE_USER,
            active: false,
        },
        [rolesConstants.OIDC_ROLES.CUSTOMER_SUPPORT_MANAGER]: {
            value: rolesConstants.OIDC_ROLES.CUSTOMER_SUPPORT_MANAGER,
            active: false,
        },
        [rolesConstants.OIDC_ROLES.CUSTOMER_SUPPORT]: {
            value: rolesConstants.OIDC_ROLES.CUSTOMER_SUPPORT,
            active: false,
        },
        [rolesConstants.OIDC_ROLES.CUSTOMER_VIEWER]: {
            value: rolesConstants.OIDC_ROLES.CUSTOMER_VIEWER,
            active: false,
        },
        [rolesConstants.OIDC_ROLES.CUSTOMER_REPORTS]: {
            value: rolesConstants.OIDC_ROLES.CUSTOMER_REPORTS,
            active: false,
        },
        [rolesConstants.OIDC_ROLES.SALES_REPORTS]: {
            value: rolesConstants.OIDC_ROLES.SALES_REPORTS,
            active: false,
        },
        [rolesConstants.OIDC_ROLES.PRODUCT_VIEWER]: {
            value: rolesConstants.OIDC_ROLES.PRODUCT_VIEWER,
            active: false,
            composite_roles: ['customer_support', 'customer_viewer', 'customer_reports'],
        },
        [rolesConstants.OIDC_ROLES.FINANCE_REPORTS]: {
            value: rolesConstants.OIDC_ROLES.FINANCE_REPORTS,
            active: false,
        },
        [rolesConstants.OIDC_ROLES.PRODUCT_MANAGER]: {
            value: rolesConstants.OIDC_ROLES.PRODUCT_MANAGER,
            active: false,
        },
    },
};

export default accessControlsMetaData;
